import React from "react";
import "./homepage.scss";
import parseMD from "parse-md";
// import * as SITE_SETTINGS from "content/site/config.json";
import classNames from "classnames";
import { Service, CoreValue } from "data/DataTypes";
import { PillarInfo } from "components/pillarInfo/pillarInfo";
import { Banner } from "components/banner/banner";
import { Tab } from "components/Tab/tab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faLongArrowAltRight } from "@fortawesome/fontawesome-free-solid";
import { PhasingGrid } from "components/PhasingGrid/phasingGrid";
import * as HOME_PAGE from "content/site/home.json";
import { convertStringToValidURL, createValidImageURL } from "data/Utils";
import { Section } from "components/Section/section";
import { ProjectCarousel } from "components/imagecarousel/imagecaursel";

type State = {
  coreValues: CoreValue[];
  services: Service[];
  instagramTitle: string;
};

export class Homepage extends React.Component<{}, State> {
  async componentDidMount() {
    // TODO Put all of this data getting into a data.ts file so its all self contained.
    const servicesMarkdownFiles = require.context(
      "content/services",
      false,
      /\.\/.*md/i
    );

    const coreValuesFiles = require.context(
      "content/coreValues",
      false,
      /\.\/.*md/i
    );

    const servicesPromises: Promise<boolean>[] = [];
    const services: Service[] = [];

    servicesMarkdownFiles.keys().forEach((markdownFile) => {
      const name = markdownFile.split(".", 2)[1] + ".md";
      const markdown = require("content/services" + name);

      // push each "fetch" of an article to a array of promises. We then listen for when all these promises are finished later, to set them to state.
      servicesPromises.push(
        fetch(markdown)
          .then((response) => {
            // fetch markdown delivers the text of the markdown
            return response.text();
          })
          .then((text) => {
            // using parse-md library to split the text from the "metadata" at top of markdown.
            let { metadata } = parseMD(text);
            const service: Service = {
              ...(metadata as Service),
            };
            service.id = convertStringToValidURL(markdownFile);
            console.log(service.id);
            // push each metadata / content as a single BlogPost object to an array of BlogPosts.
            services.push({
              ...service,
            });
            return true;
          })
          .catch((e) => {
            // this should never happen... but you know
            //  console.log(e);
            return false;
          })
      );
    });

    const coreValuesPromises: Promise<boolean>[] = [];
    const coreValues: CoreValue[] = [];

    coreValuesFiles.keys().forEach((markdownFile) => {
      const name = markdownFile.split(".", 2)[1] + ".md";
      const markdown = require("content/coreValues" + name);

      coreValuesPromises.push(
        fetch(markdown)
          .then((response) => {
            // fetch markdown delivers the text of the markdown
            return response.text();
          })
          .then((text) => {
            // using parse-md library to split the text from the "metadata" at top of markdown.
            const { metadata } = parseMD(text);

            // push each metadata / content as a single BlogPost object to an array of BlogPosts.
            coreValues.push({
              ...(metadata as CoreValue),
            });
            return true;
          })
          .catch((e) => {
            // this should never happen... but you know
            //  console.log(e);
            return false;
          })
      );
    });

    Promise.all(servicesPromises).then(() => {
      services.sort((a, b) => {
        return a.title.localeCompare(b.title);
      });

      this.setState({ services });
    });

    Promise.all(coreValuesPromises).then(() => {
      coreValues.sort((a, b) => {
        return a.title.localeCompare(b.title);
      });

      this.setState({ coreValues });
    });
  }

  render() {
    // const config = SITE_SETTINGS;
    const data = HOME_PAGE;

    if (!this.state || !this.state.services || !this.state.coreValues) return;
    return (
      <div className="Homepage_root">
        <div
          className={classNames(
            "relative text-blackColor bg-whiteColor w-full text-center pb-10 pt-20 mt-16"
          )}
        >
          <Section>
            <h1 className="font-semibold break-keep max-w-7xl ml-auto mr-auto">
              {data.headerdescription}
            </h1>
            <h3 className="font-light text-secondAccent break-keep max-w-7xl ml-auto mr-auto">
              {data.headerSubDescription}
            </h3>
          </Section>
        </div>
        {/* <YoutubeIFrame src={data.video}></YoutubeIFrame> */}
        <ProjectCarousel projects={this.state.services} />
        <div className="Homepage_content">
          <PillarInfo
            title={data.coreValuesHeader}
            pillars={this.state.coreValues.map((cv) => {
              return (
                <>
                  {/* <img src={createValidImageURL(cv.cover)} alt={cv.title} /> */}
                  <div
                    className={`text-blackColor text-left rounded-md p-20 flex-1 ${cv.pillarType}`}
                  >
                    <h4 className="text-blackColor font-light">{cv.title}</h4>
                    <h3 className="text-secondAccent font-semibold">
                      {cv.description}
                    </h3>
                  </div>
                </>
              );
            })}
          />
          <Banner modifiers="alt2 alignCenter marginBottom relative">
            <div className="w-full h-full absolute opacity-60">
              <PhasingGrid />
            </div>
            <div className="flex flex-col md:flex-row items-center p-24">
              <img
                className="w-full md:w-1/3 h-auto object-contain mr-10"
                src={createValidImageURL(data.getQuoteImage)}
                alt={data.getQuoteButtonText}
              />

              <div className="w-full md:w-2/3">
                <h2 className="font-normal break-keep text-blackColor">
                  {data.getQuoteHeader}
                </h2>
                <br />
                <div className="Banner_table">
                  <p>
                    {data.getQuoteDescription}
                    <br />
                    <br />
                    <Tab
                      modifiers={classNames("special noMargin")}
                      label={data.getQuoteButtonText}
                      to="/Contact"
                      children={
                        <FontAwesomeIcon
                          className="Header_arrowIcon"
                          icon={faLongArrowAltRight as IconProp}
                        />
                      }
                    />
                  </p>
                </div>
              </div>
            </div>
          </Banner>
        </div>
      </div>
    );
  }
}
